// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2QpPA","col":"styles_col__1gCWY","fulfillmentStatus":"styles_fulfillmentStatus__zV6S_","emailCol":"styles_emailCol__hFw_g"};